import { render, staticRenderFns } from "./LabelEnums.vue?vue&type=template&id=e09ddf04"
import script from "./LabelEnums.vue?vue&type=script&lang=js"
export * from "./LabelEnums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports